import React from "react";
import { Flex } from "@chakra-ui/react";
import { AccordionItem } from "components";
import { TploForm, PreoperativeTpa } from "./components";

const Tplo: React.FC = () => {
  return (
    <Flex mt={6} direction="column" gap={6}>
      <AccordionItem title="Tibial Plateau Leveling Osteotomy Planning">
        <TploForm />
        <PreoperativeTpa />
      </AccordionItem>
    </Flex>
  );
};

export default Tplo;
